import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("canvas", { id: "combat-canvas" }, null, -1)
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", null, "Select a scene", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = { tabindex: "-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", null, "Conditions", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { id: "visits" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["checked", "onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","font-size":"25px"} }, " Press F4 to toggle debug mode ", -1)
const _hoisted_15 = {
  key: 0,
  class: "screen-too-small"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = ["volume"]
const _hoisted_19 = { class: "scene-txt dys-letter dys-size0" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = ["volume", "src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = ["href"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["tabindex", "onClick"]
const _hoisted_27 = { class: "choice-text" }
const _hoisted_28 = {
  key: 0,
  class: "visited-label"
}
const _hoisted_29 = { class: "bottom-bar" }
const _hoisted_30 = { class: "music-display dys-size2 dys-letter" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", { src: "img/icons/musical-note.png" }, null, -1)
const _hoisted_32 = { class: "notes-panel" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", { src: "img/icons/blood_note.png" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", { src: "img/icons/golden_note.png" }, null, -1)
const _hoisted_35 = ["tabindex"]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", { src: "img/icons/cog.png" }, null, -1)
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", null, "Click anywhere to continue", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e14040"} }, "GAME OVER", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"25px","color":"lightgray","margin-bottom":"20px"} }, " You can do it! ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", null, "Click anywhere to go to last checkpoint", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", null, "Press 'R' to retry", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e14040"} }, "Photosensitivity warning", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"25px","color":"lightgray","margin-bottom":"20px"} }, " A small percentage of people may experience seizures when exposed to certain lights, patterns or images, even with no history of epilepsy or seizures. ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { style: {"animation":"none"} }, "Click anywhere to continue", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"purple"} }, "Got 3 golden notes !", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"25px","color":"lightgray","margin-bottom":"20px"} }, " You can now go to the chord gate and break the seal ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", null, "Click anywhere to continue", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", null, "Thanks for playing!", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"25px","color":"lightgray","margin-bottom":"20px"} }, " Chapter 3 will be released soon™ ", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", null, "Click anywhere to go back to begining", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"40px"} }, "or", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", null, "Don't click anywhere and listen to this sick saxophone solo", -1)
const _hoisted_54 = { class: "title-bar" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "title dys-letter dys-line" }, "Settings", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", {
  class: "close-button",
  src: "img/icons/cross.png"
}, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "dys-line dys-letter" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h2", { style: {"text-decoration":"underline","margin-bottom":"10px"} }, "Audio", -1)
const _hoisted_60 = ["value"]
const _hoisted_61 = ["value"]
const _hoisted_62 = ["value"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h2", { style: {"text-decoration":"underline"} }, "Accessibility", -1)
const _hoisted_64 = { style: {"margin-bottom":"15px"} }
const _hoisted_65 = { class: "switch" }
const _hoisted_66 = ["checked"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_68 = { style: {"margin-bottom":"15px"} }
const _hoisted_69 = { class: "switch" }
const _hoisted_70 = ["checked"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_72 = { style: {"margin-bottom":"15px"} }
const _hoisted_73 = { class: "switch" }
const _hoisted_74 = ["checked"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_76 = { style: {"margin-bottom":"15px"} }
const _hoisted_77 = { class: "switch" }
const _hoisted_78 = ["checked"]
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_80 = { style: {"margin-bottom":"15px"} }
const _hoisted_81 = { class: "switch" }
const _hoisted_82 = ["checked"]
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h2", { style: {"text-decoration":"underline","margin-bottom":"10px"} }, " Miscellaneous ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px"} }, " Hold CTRL and use the mouse wheel or +/- keys to zoom in or out on the UI. ", -1)
const _hoisted_86 = ["disabled"]
const _hoisted_87 = ["disabled"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/icons/in_progress.png",
  class: "wip_stamp"
}, null, -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://leandro4002.itch.io/diapason-of-fate",
  class: "itch-link-container",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "17",
    src: "img/icons/external.png"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "itch-link" }, "itch.io page")
], -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://saraivam.ch",
  class: "itch-link-container",
  style: {"margin-left":"20px"},
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "17",
    src: "img/icons/external.png"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "itch-link" }, "personal website")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ShowHide = _resolveComponent("ShowHide")!
  const _component_CombatCanvas = _resolveComponent("CombatCanvas")!
  const _component_ClosingCredits = _resolveComponent("ClosingCredits")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(`main ${_ctx.bools.dyslexic ? 'dyslexic dys-size' : ''}`)
    }, [
      _createVNode(_component_router_view),
      _createElementVNode("div", {
        style: _normalizeStyle(`display: ${_ctx.bools.showDebug ? 'inherit' : 'none'}`),
        class: "debug"
      }, [
        _createTextVNode(" Select scene : "),
        _createElementVNode("select", {
          tabindex: "-1",
          disabled: _ctx.bools.sentenceExecuting,
          onChange: _cache[0] || (_cache[0] = 
          (e) => {
            _ctx.DEBUG_loadScene(e.target);
          }
        )
        }, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.scenes), (sceneName) => {
            return (_openBlock(), _createElementBlock("option", {
              value: sceneName,
              key: sceneName
            }, _toDisplayString(sceneName), 9, _hoisted_4))
          }), 128))
        ], 40, _hoisted_2),
        _createElementVNode("select", _hoisted_5, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditions, (condition) => {
            return (_openBlock(), _createElementBlock("option", {
              value: condition,
              key: condition
            }, _toDisplayString(condition), 9, _hoisted_7))
          }), 128))
        ]),
        _createTextVNode(" sentenceMutex.isLocked : " + _toDisplayString(_ctx.sentenceSemaphore.isLocked()) + " ", 1),
        _hoisted_8,
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.conditions = []))
        }, "Clear conditions"),
        _createElementVNode("button", {
          tabindex: "-1",
          disabled: _ctx.bools.sentenceExecuting,
          onClick: _cache[2] || (_cache[2] = 
          () => {
            if (_ctx.strings.currentScene != null && !_ctx.bools.sentenceExecuting)
              _ctx.loadScene(_ctx.strings.currentScene);
          }
        )
        }, " Reload scene ", 8, _hoisted_9),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.shakeImage && _ctx.shakeImage(...args)))
        }, "Shake"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.skipSentence && _ctx.skipSentence(...args)))
        }, "Skip sentence"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[5] || (_cache[5] = ($event: any) => {
          _ctx.audioSources.music_background.setCurrentTime(
            _ctx.audioSources.music_background.getDuration()
          );
          _ctx.audioSources.music_background.pause();
        })
        }, " Skip battle "),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (++_ctx.goldenNotes))
        }, "++goldenNotes"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (--_ctx.goldenNotes))
        }, "--goldenNotes"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (++_ctx.bloodNotes))
        }, "++bloodNotes"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (--_ctx.bloodNotes))
        }, "--bloodNotes"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetSave && _ctx.resetSave(...args)))
        }, "Reset save"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setAllNotif('0')))
        }, "Clear all notif"),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setAllNotif('1')))
        }, " Re-activate all notif "),
        _createElementVNode("button", {
          tabindex: "-1",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setAllBossesConditions()))
        }, " Set all boss fight conditions "),
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strings, (stringText, stringName) => {
          return (_openBlock(), _createElementBlock("span", {
            key: stringName,
            style: {"margin-right":"10px","min-width":"400px","display":"inline-block"}
          }, _toDisplayString(stringName) + ": \"" + _toDisplayString(stringText) + "\" ", 1))
        }), 128)),
        _hoisted_11,
        _hoisted_12,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bools, (isTrue, boolName) => {
          return (_openBlock(), _createElementBlock("label", {
            key: boolName,
            style: {"margin-right":"10px","min-width":"180px","display":"inline-block"}
          }, [
            _createTextVNode(_toDisplayString(boolName) + " ", 1),
            _createElementVNode("input", {
              checked: isTrue,
              type: "checkbox",
              tabindex: "-1",
              onClick: ($event: any) => (_ctx.bools[boolName] = !isTrue)
            }, null, 8, _hoisted_13)
          ]))
        }), 128)),
        _hoisted_14
      ], 4),
      (_ctx.bools.screenTooSmall)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createTextVNode(" Your screen is too small. "),
            _hoisted_16,
            _createTextVNode(" Hold CTRL and use the mouse wheel or +/- keys to zoom in or out on the UI. "),
            _hoisted_17,
            _createTextVNode(" (minimum 1350px wide) ")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("video", {
        tabindex: "-1",
        preload: "auto",
        volume: _ctx.musicVolume,
        disablePictureInPicture: "",
        controlsList: "nodownload",
        id: "horrible-transition",
        class: "horrible-transition",
        src: "cinematics/horrible_transition.mp4"
      }, null, 8, _hoisted_18),
      _createElementVNode("div", {
        id: "image-panel",
        class: _normalizeClass(`image-container`),
        style: _normalizeStyle(`height: ${_ctx.bools.showCinematic ? 28 : 19}em`)
      }, [
        _createVNode(_component_ShowHide, {
          "is-shown": _ctx.bools.showImage,
          "duration-ms": 1000,
          "on-hide-end": _ctx.onImageHideEnd,
          "on-show-end": _ctx.onImageShowEnd,
          "shown-style": "height: 100%",
          "hidden-style": "filter: brightness(0); height: 100%"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.currentImageClean), 1),
            _createElementVNode("img", {
              src: `img/scenes/${_ctx.strings.currentImage}.${
            _ctx.strings.currentImage.startsWith('the_singer') ? 'gif' : 'jpg'
          }`,
              class: "scene-img",
              onLoad: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onImageLoad && _ctx.onImageLoad(...args)))
            }, null, 40, _hoisted_20)
          ]),
          _: 1
        }, 8, ["is-shown", "on-hide-end", "on-show-end"]),
        _createVNode(_component_ShowHide, {
          "is-shown": _ctx.bools.showCharacter,
          "duration-ms": 1000
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: `img/characters/${_ctx.strings.currentCharacter}.png`,
              alt: `character ${_ctx.strings.currentCharacter}`,
              class: _normalizeClass(`onTop-img ${
            _ctx.bools.characterWiggle ? 'character-wiggle' : ''
          }`)
            }, null, 10, _hoisted_21)
          ]),
          _: 1
        }, 8, ["is-shown"]),
        _createVNode(_component_ShowHide, {
          "is-shown": _ctx.bools.isLoading,
          "trans-function": "ease-in",
          "duration-ms": _ctx.bools.isLoading ? 5000 : 200,
          class: "loading"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Loading... ")
          ]),
          _: 1
        }, 8, ["is-shown", "duration-ms"]),
        _createVNode(_component_ShowHide, {
          "is-shown": _ctx.bools.showCinematic,
          "duration-ms": 1000,
          "hidden-style": "opacity: 0",
          "on-hide-end": _ctx.onCinematicHideEnd,
          "on-show-end": _ctx.onCinematicShowEnd
        }, {
          default: _withCtx(() => [
            _createElementVNode("video", {
              tabindex: "-1",
              onPause: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onCinematicPause && _ctx.onCinematicPause(...args))),
              onCanplaythrough: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onCinematicLoad && _ctx.onCinematicLoad(...args))),
              disablePictureInPicture: "",
              controlsList: "nodownload",
              volume: _ctx.musicVolume,
              id: "cinematic",
              class: "cinematic",
              src: `cinematics/${_ctx.strings.currentCinematic}.mp4`
            }, [
              _createElementVNode("track", {
                kind: "captions",
                srclang: "en",
                src: `cinematics/${_ctx.strings.currentCinematic}.vtt`
              }, null, 8, _hoisted_23),
              _createElementVNode("a", {
                href: `cinematics/${_ctx.strings.currentCinematic}.mp4`
              }, " Download video ", 8, _hoisted_24)
            ], 40, _hoisted_22)
          ]),
          _: 1
        }, 8, ["is-shown", "on-hide-end", "on-show-end"])
      ], 4),
      _createVNode(_component_ShowHide, {
        "is-shown": _ctx.bools.showBattle,
        "trans-function": "linear",
        "duration-ms": 1000,
        "on-hide-end": _ctx.onBattleHideEnd,
        "on-show-end": _ctx.onBattleShowEnd,
        "shown-style": "height: 17em;",
        "hidden-style": "height: 0; margin-top: 0; opacity: 0;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CombatCanvas, {
            dyslexic: _ctx.bools.dyslexic,
            "fx-volume": _ctx.soundEffectsVolume,
            "set-h-p": (x) => { if (x <= 0) {
          _ctx.gameover();
        } },
            "update-stuff": (stuff) => {
          _ctx.bools.showBattle = stuff.showBattle;
          _ctx.bools.battleActive = stuff.battleActive;

          _ctx.loadScene(stuff.nextScene);
        },
            "enable-screen-shake": _ctx.bools.screenShake,
            invincible: _ctx.bools.invincible,
            "show-debug": _ctx.bools.showDebugBattle,
            "battle-name": _ctx.strings.currentBattle,
            "battle-time": _ctx.battleTime,
            "override-display-singer": _ctx.overrideDisplaySinger,
            "is-active": _ctx.bools.battleActive,
            "reload-request": _ctx.bools.reloadRequest,
            "audio-sources": _ctx.audioSources
          }, null, 8, ["dyslexic", "fx-volume", "set-h-p", "update-stuff", "enable-screen-shake", "invincible", "show-debug", "battle-name", "battle-time", "override-display-singer", "is-active", "reload-request", "audio-sources"])
        ]),
        _: 1
      }, 8, ["is-shown", "on-hide-end", "on-show-end"]),
      _createVNode(_component_ShowHide, {
        "trans-function": "linear",
        "is-shown": _ctx.bools.showText,
        "duration-ms": 1000,
        "hidden-style": "height: 0em; padding-top: 0; padding-bottom: 0; opacity: 0",
        "shown-style": "height: 6.8em",
        class: _normalizeClass(["text-container dys-line dys-quickfix", 
        _ctx.bools.sentenceExecuting
          ? _ctx.bools.dyslexic
            ? 'text-skippable-dys'
            : 'text-skippable'
          : ''
      ]),
        onClick: _ctx.skipSentence,
        id: "textContainer"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sentences, (s) => {
            return (_openBlock(), _createElementBlock("span", {
              key: s.text,
              class: _normalizeClass(`${_ctx.bools.dyslexic ? 'dyslexic' : ''} ${
          s.noAnim ? '' : 'typewriter'
        } ${s.customClass}`),
              style: _normalizeStyle(`
			--num-char:${s.text.length};
			--time-per-letter: ${s.timePerLetter}s;
			--color: ${s.customColor};
			${s.noAnim ? 'color: ' + s.customColor : ''};
			font-family: '${s.overrideFont !== '' ? s.overrideFont : _ctx.strings.currentFont}`),
              onAnimationend: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.animatedSentenceEnd && _ctx.animatedSentenceEnd(...args)))
            }, [
              _createTextVNode(_toDisplayString(s.text), 1),
              (s.newLine)
                ? (_openBlock(), _createElementBlock("br", _hoisted_25))
                : _createCommentVNode("", true)
            ], 38))
          }), 128)),
          (_ctx.bools.textSkippable)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`${_ctx.bools.dyslexic ? 'dyslexic' : ''} text-skip-info ${
          _ctx.bools.skipFlicker ? 'text-skip-flicker' : ''
        }`)
              }, " CTRL or click to continue ", 2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["is-shown", "class", "onClick"]),
      _createVNode(_component_ShowHide, {
        class: "choice-container",
        "hidden-style": "height: 0em;",
        "shown-style": "height: 10em",
        "is-shown": _ctx.bools.showChoices,
        "duration-ms": 1000,
        "trans-function": "linear"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choices, (choice) => {
            return (_openBlock(), _createElementBlock("div", {
              key: choice.text,
              style: _normalizeStyle(_ctx.choices.length === 1 ? 'width: 100%' : '')
            }, [
              _createElementVNode("button", {
                tabindex: !_ctx.bools.showChoices || _ctx.bools.showSettings ? -1 : 0,
                onClick: ($event: any) => (_ctx.onClickChoice(choice)),
                onMouseenter: _cache[18] || (_cache[18] = 
            () => {
              if (!_ctx.bools.sentenceExecuting) _ctx.audioSources.effects_hover.play();
            }
          ),
                class: _normalizeClass(` ${_ctx.bools.dyslexic ? 'dyslexic dys-size dys-letter' : ''} ${
            _ctx.bools.choicesInvisible ? 'invisible' : ''
          } ${
            _ctx.bools.sentenceExecuting
              ? _ctx.bools.dyslexic
                ? 'executing-text-dys'
                : 'executing-text'
              : ''
          }`)
              }, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(choice.text), 1),
                (choice.visited && !_ctx.bools.choicesInvisible)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Seen "))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_26)
            ], 4))
          }), 128))
        ]),
        _: 1
      }, 8, ["is-shown"]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_ShowHide, {
          "is-shown": _ctx.bools.showMusic,
          "duration-ms": 1000,
          "on-hide-end": _ctx.onMusicHideEnd,
          "on-show-end": _ctx.onMusicShowEnd
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_30, [
              _hoisted_31,
              _createTextVNode(" " + _toDisplayString(_ctx.strings.currentMusic), 1)
            ])
          ]),
          _: 1
        }, 8, ["is-shown", "on-hide-end", "on-show-end"]),
        _createElementVNode("span", _hoisted_32, [
          _createElementVNode("span", {
            class: _normalizeClass(`notes-num ${_ctx.bloodNotes <= 0 ? 'notes-invisible' : ''}`)
          }, [
            _hoisted_33,
            _createTextVNode(" blood notes: " + _toDisplayString(_ctx.bloodNotes), 1)
          ], 2),
          _createElementVNode("span", {
            class: _normalizeClass(`notes-num ${_ctx.goldenNotes <= 0 ? 'notes-invisible' : ''}`)
          }, [
            _hoisted_34,
            _createTextVNode(" golden notes: " + _toDisplayString(_ctx.goldenNotes), 1)
          ], 2)
        ]),
        _createElementVNode("button", {
          tabindex: !_ctx.bools.showChoices || _ctx.bools.showSettings ? -1 : 0,
          class: "options dys-size2",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onClickSettings()))
        }, [
          _createTextVNode(" Settings"),
          _hoisted_36,
          _createElementVNode("img", {
            style: _normalizeStyle(`${_ctx.isThereANotif() ? '' : 'display:none'}`),
            src: "img/icons/notification_alt.png",
            class: "notification notification-options"
          }, null, 4)
        ], 8, _hoisted_35)
      ]),
      _createVNode(_component_ClosingCredits, {
        "is-shown": _ctx.bools.showCredits,
        style: _normalizeStyle(!_ctx.bools.showCredits ? 'user-select: none' : ''),
        "on-credits-close": () => (_ctx.bools.showCredits = false)
      }, null, 8, ["is-shown", "style", "on-credits-close"]),
      _createVNode(_component_VueFinalModal, {
        modelValue: _ctx.showGotNote,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showGotNote) = $event)),
        "overlay-class": `ephemeral-prompt-overlay ${
        _ctx.bools.dyslexic ? 'dyslexic' : ''
      }`,
        "content-class": "ephemeral-prompt-content",
        style: {"cursor":"pointer"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            style: _normalizeStyle(`color: ${_ctx.isBloodNote() ? '#e14040' : '#d4af37'}`)
          }, _toDisplayString(_ctx.isBloodNote() ? "Blood note" : "Golden note") + " obtained", 5),
          _createElementVNode("img", {
            src: `img/icons/${_ctx.isBloodNote() ? 'blood_note' : 'golden_note'}.png`
          }, null, 8, _hoisted_37),
          _hoisted_38
        ]),
        _: 1
      }, 8, ["modelValue", "overlay-class"]),
      _createVNode(_component_VueFinalModal, {
        modelValue: _ctx.showGameover,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showGameover) = $event)),
        "overlay-class": "ephemeral-prompt-overlay",
        "content-class": "ephemeral-prompt-content",
        style: {"cursor":"pointer"}
      }, {
        default: _withCtx(() => [
          _hoisted_39,
          _hoisted_40,
          _hoisted_41,
          _hoisted_42
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_VueFinalModal, {
        modelValue: _ctx.showEpilepsyWarning,
        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showEpilepsyWarning) = $event)),
        "overlay-class": "ephemeral-prompt-overlay",
        "content-class": "ephemeral-prompt-content",
        style: {"cursor":"pointer"}
      }, {
        default: _withCtx(() => [
          _hoisted_43,
          _hoisted_44,
          _hoisted_45
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_VueFinalModal, {
        modelValue: _ctx.showGot3Notes,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.showGot3Notes) = $event)),
        "overlay-class": "ephemeral-prompt-overlay",
        "content-class": "ephemeral-prompt-content",
        style: {"cursor":"pointer"}
      }, {
        default: _withCtx(() => [
          _hoisted_46,
          _hoisted_47,
          _hoisted_48
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_VueFinalModal, {
        modelValue: _ctx.showGameEnd,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.showGameEnd) = $event)),
        "overlay-class": "ephemeral-prompt-overlay",
        "content-class": "ephemeral-prompt-content",
        style: {"cursor":"pointer"}
      }, {
        default: _withCtx(() => [
          _hoisted_49,
          _hoisted_50,
          _hoisted_51,
          _hoisted_52,
          _hoisted_53
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_VueFinalModal, {
        modelValue: _ctx.bools.showSettings,
        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.bools.showSettings) = $event)),
        "overlay-class": "settings-overlay",
        "content-class": "settings-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("button", {
              class: "close-button-container",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.bools.showSettings = false))
            }, _hoisted_57)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", null, [
              _createTextVNode(" Master volume " + _toDisplayString(Math.round(_ctx.masterVolume * 100)) + "% ", 1),
              _createElementVNode("input", {
                type: "range",
                min: "0",
                max: "100",
                value: _ctx.masterVolume * 100,
                class: "horizontal-slider",
                onWheel: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onWheelMasterVolume && _ctx.onWheelMasterVolume(...args))),
                onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.onMasterVolumeChange && _ctx.onMasterVolumeChange(...args)))
              }, null, 40, _hoisted_60)
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" Music volume " + _toDisplayString(Math.round(_ctx.musicVolume * 100)) + "% ", 1),
              _createElementVNode("input", {
                type: "range",
                min: "0",
                max: "100",
                value: _ctx.musicVolume * 100,
                class: "horizontal-slider",
                onWheel: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.onWheelMusicVolume && _ctx.onWheelMusicVolume(...args))),
                onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.onMusicVolumeChange && _ctx.onMusicVolumeChange(...args)))
              }, null, 40, _hoisted_61)
            ]),
            _createElementVNode("div", null, [
              _createTextVNode(" Sound effects volume " + _toDisplayString(Math.round(_ctx.soundEffectsVolume * 100)) + "% ", 1),
              _createElementVNode("input", {
                type: "range",
                min: "0",
                max: "100",
                value: _ctx.soundEffectsVolume * 100,
                class: "horizontal-slider",
                onWheel: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.onWheelSoundEffectsVolume && _ctx.onWheelSoundEffectsVolume(...args))),
                onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.onSoundEffectsVolumeChange && _ctx.onSoundEffectsVolumeChange(...args)))
              }, null, 40, _hoisted_62)
            ]),
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, [
              _createTextVNode(" Show subtitles during cinematics "),
              _createElementVNode("label", _hoisted_65, [
                _createElementVNode("input", {
                  type: "checkbox",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.onCinematicCaptionsToggle())),
                  checked: _ctx.bools.showCinematicCaptions
                }, null, 8, _hoisted_66),
                _hoisted_67
              ])
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createTextVNode(" Use dyslexic font "),
              _createElementVNode("label", _hoisted_69, [
                _createElementVNode("input", {
                  type: "checkbox",
                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onDyslexicToggle())),
                  checked: _ctx.bools.dyslexic
                }, null, 8, _hoisted_70),
                _hoisted_71
              ])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _createTextVNode(" Enable screenshake "),
              _createElementVNode("label", _hoisted_73, [
                _createElementVNode("input", {
                  type: "checkbox",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onScreenShakeToggle())),
                  checked: _ctx.bools.screenShake
                }, null, 8, _hoisted_74),
                _hoisted_75
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createTextVNode(" Visual help (for color vision deficiency) "),
              _createElementVNode("label", _hoisted_77, [
                _createElementVNode("input", {
                  type: "checkbox",
                  onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onVisualHelpToggle())),
                  checked: _ctx.getVisualHelp()
                }, null, 8, _hoisted_78),
                _hoisted_79
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createTextVNode(" Invincibility "),
              _createElementVNode("label", _hoisted_81, [
                _createElementVNode("input", {
                  type: "checkbox",
                  onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.onInvincibleToggle())),
                  checked: _ctx.bools.invincible
                }, null, 8, _hoisted_82),
                _hoisted_83
              ])
            ]),
            _hoisted_84,
            _hoisted_85,
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: _normalizeClass(`credits-button ${_ctx.bools.dyslexic ? 'dyslexic' : ''}`),
                disabled: _ctx.strings.currentScene === null || _ctx.bools.sentenceExecuting,
                onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.startChapter(1))),
                onMouseover: _cache[38] || (_cache[38] = ($event: any) => (_ctx.clearNotif('startChapter1')))
              }, [
                _createTextVNode(" Start at chapter 1 "),
                _createElementVNode("img", {
                  style: _normalizeStyle(`${
                _ctx.notifications.get('startChapter1') === '1' ? '' : 'display:none'
              }`),
                  src: "img/icons/notification_alt.png",
                  class: "notification notification-button"
                }, null, 4)
              ], 42, _hoisted_86),
              _createElementVNode("button", {
                class: _normalizeClass(`credits-button ${_ctx.bools.dyslexic ? 'dyslexic' : ''}`),
                disabled: _ctx.strings.currentScene === null || _ctx.bools.sentenceExecuting,
                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.startChapter(2))),
                onMouseover: _cache[40] || (_cache[40] = ($event: any) => (_ctx.clearNotif('startChapter2')))
              }, [
                _createTextVNode(" Start at chapter 2 "),
                _createElementVNode("img", {
                  style: _normalizeStyle(`${
                _ctx.notifications.get('startChapter2') === '1' ? '' : 'display:none'
              }`),
                  src: "img/icons/notification_alt.png",
                  class: "notification notification-button"
                }, null, 4)
              ], 42, _hoisted_87),
              _createElementVNode("button", {
                class: _normalizeClass(`credits-button ${_ctx.bools.dyslexic ? 'dyslexic' : ''} wip`),
                disabled: true,
                title: "Coming soon™"
              }, [
                _createTextVNode(" Start at chapter 3 "),
                _hoisted_88
              ], 2)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: _normalizeClass(`credits-button ${
              _ctx.bools.dyslexic ? 'dyslexic' : ''
            } reset-progress`),
                onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.resetSave && _ctx.resetSave(...args)))
              }, " Reset progress ", 2)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: _normalizeClass(`credits-button ${_ctx.bools.dyslexic ? 'dyslexic' : ''}`),
                onClick: _cache[42] || (_cache[42] = ($event: any) => {
              _ctx.bools.showCredits = true;
              _ctx.bools.showSettings = false;
            })
              }, " Show credits ", 2)
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.numUniqueVisits) + " unique visits", 1),
            _hoisted_89,
            _hoisted_90,
            _hoisted_91
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2)
  ], 64))
}